<script setup lang="ts">
import { onMounted } from 'vue';

import { captureTrackingValues, populateTrackingInput } from '@/utils/trackingValues';

onMounted(() => {
  captureTrackingValues();
  populateTrackingInput();
});
</script>

<template>
  <span style="display: none;" />
</template>
